window.mcb.forms.fields = window.mcb.forms.fields || {};
window.mcb.forms.fields.extensions = window.mcb.forms.fields.extensions || {};
window.mcb.forms.fields.extensions.choiceAsSelect = function (parent, shared) {
    const _logger = window.mcb.utilities.createLogger("forms.field.select", 'Forms Field (Select)');
    const _thisField = parent;
    const _shared = shared;
    let _validatedControlWrapper = null;
    const _controls = [];
    let _validationCanvas = null;

    {
        // Init
        _thisField.validation = {
            required: _thisField.settings.required ?? false,
            dirty: false,
        };
    }

    const render = function (fieldGroup) {
        fieldGroup.classList.add(window.mcb.forms.constants.fields.dropdownClass);

        const wrapper = document.createElement('select');
        wrapper.classList.add(window.mcb.forms.constants.fields.uiInput);
        wrapper.classList.add(window.mcb.forms.constants.fields.controlClass);
        wrapper.classList.add(window.mcb.forms.constants.fields.selectClass);
        wrapper.id = _thisField.fieldValueControlId;
        wrapper.name = _thisField.alias;

        if (_thisField.settings.data.multiple === true) {
            wrapper.multiple = true;
        }

        if (_thisField.settings.data.prompt !== null) {
            const injected = document.createElement('option');
            injected.selected = _thisField.settings.data.multiple !== true;
            injected.disabled = true;
            injected.value = '';
            injected.innerText = _thisField.settings.data.prompt;
            wrapper.append(injected);
        }

        for (
            let k = 0; k < _thisField.settings.data.choices.length; k++
        ) {
            const option = document.createElement('option');
            option.id = _thisField.fieldValueControlId + '_option_' + k;
            option.selected = _thisField.settings.data.choices[k].value === _thisField.settings.defaultValue;
            option.value = _thisField.settings.data.choices[k].value;
            option.innerText = _thisField.settings.data.choices[k].caption;
            wrapper.append(option);
            _controls.push(option);
        }

        wrapper.addEventListener('focus', (event) => {
            _shared.validateEvent(event, _thisField, wrapper);
            _shared.fireFieldModifiedEvents(wrapper, _thisField.applyValidationDuringInput);
        });

        wrapper.addEventListener('change', (event) => {
            _shared.validateEvent(event, _thisField, wrapper);
            _shared.fireFieldModifiedEvents(wrapper, _thisField.applyValidationDuringInput);
        });

        wrapper.addEventListener('blur', (event) => {
            _shared.validateEvent(event, _thisField, wrapper);
            _shared.fireFieldModifiedEvents(wrapper, _thisField.applyValidationDuringInput);
        });

        _validationCanvas = document.createElement('div');
        _validationCanvas.classList.add(window.mcb.forms.constants.validation.validationTarget);

        _validatedControlWrapper = document.createElement('div');
        _validatedControlWrapper.classList.add(window.mcb.forms.constants.validation.validationWrapper);

        _validatedControlWrapper.appendChild(wrapper);
        _validatedControlWrapper.appendChild(_validationCanvas);

        return _validatedControlWrapper;
    };

    const getValue = function () {
        window.mcb.forms.validation.clearValidationResults(_validationCanvas);

        if (_validationCanvas === null) {
            throw new Error("Control is not initialized");
        }

        for (let i = 0; i < _controls.length; i++) {
            if (document.getElementById(_controls[i].id) === null) {
                throw new Error("Control has been removed from DOM");
            }
        }

        if (_validationCanvas.offsetParent === null) {
            // Field is not visible
            return undefined;
        }

        const values = [];
        for (let i = 0; i < _thisField.settings.data.choices.length; i++) {
            const control = _controls[i];
            if (control.selected) {
                values.push(_thisField.settings.data.choices[i].value);
            }
        }

        var value = values.join('|');

        const validation = new window.mcb.forms.validation.ValidationResult(true);
        if (_thisField.validation.required === true) {
            validation.aggregate(window.mcb.forms.validation.validateRequired(_thisField.alias, value));
        }

        if (!_thisField.settings.data.multiple && values.length > 1) {
            validation.aggregate(new window.mcb.forms.validation.ValidationResult(false, "ChoiceHasTooManyValues", values));
        }

        validation.render(_thisField.formId, _validatedControlWrapper, _validationCanvas);
        if (validation.isValid()) {
            return value;
        }

        return null;
    };

    const setValue = function (value) {
        const valueArray = value.split('|');
        for (let i = 0; i < valueArray.length; i++) {
            valueArray[i] = valueArray[i].trim();
        }

        for (let i = 0; i < _controls.length; i++) {
            const control = _controls[i];
            const index = valueArray.indexOf(control.value);
            if (index >= 0) {
                control.checked = true;
                valueArray.splice(index, 1);
            } else {
                control.checked = false;
            }
        }

        if (valueArray.length > 0) {
            _logger.warn('failedMultiChoiceValues', valueArray);
        }

        return valueArray.length === 0;
    }

    return _ = {
        render: render,
        getValue: getValue,
        setValue: setValue
    };
};
